import { connect } from 'react-redux';

import { getProducts } from '../selectors';
import * as brandsSelectors from '../../brands/selectors';
import * as categoriesSelectors from '../../categories/selectors';
import { getPoVendors } from '../../purchaseOrders/vendors/store/selectors';

const withProducts = connect((state) => {
  const categories = categoriesSelectors.getAll(state);
  const brands = brandsSelectors.getAll(state);
  const vendors = getPoVendors(state);

  return {
    products: getProducts(state, categories, brands, vendors),
  };
});

export default withProducts;
